const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'discount_bubble',
    modelClass: Backbone.Model,
    viewClass: require('./view'),
});
